import vue2DatepickerKo from 'vue2-datepicker/locale/ko'

/** Bootstrap-Vue b-form-datepicker */
export const DATEPICKER_LOCALE = 'ko'

/**
 * b-form-datepicker / b-calendar 개별 label prop
 * (:labels 객체는 BV 2.x에서 동작하지 않음 → v-bind로 전달)
 */
export const B_FORM_DATEPICKER_LABELS = {
	labelPrevDecade: '이전 10년',
	labelPrevYear: '이전 해',
	labelPrevMonth: '이전 달',
	labelCurrentMonth: '현재 달',
	labelNextMonth: '다음 달',
	labelNextYear: '다음 해',
	labelNextDecade: '다음 10년',
	labelToday: '오늘',
	labelSelected: '선택된 날짜',
	labelNoDateSelected: '선택된 날짜 없음',
	labelCalendar: '달력',
	labelNav: '달력 탐색',
	labelHelp: '커서 키로 날짜를 탐색하세요'
}

export const DATEPICKER_FORMAT_OPTIONS = {
	year: 'numeric',
	month: 'long',
	day: 'numeric',
	weekday: 'short'
}

/** vue2-datepicker (range 등) — 달력 헤더: 2026년 4월 형식 */
export const VUE2_DATEPICKER_LANG = {
	...vue2DatepickerKo,
	yearFormat: 'YYYY년',
	monthFormat: 'MMM',
	monthBeforeYear: false
}
